import React, { FC, MutableRefObject } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import { isC2RTransaction } from 'data/transactions/utils';
import RegPayeeField from './RegPayeeField';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface PayeeFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  callbacks: CallbacksType;
  editable: boolean;
  SHOW_ALL: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  wrapClass: string; 
  editClass: string; 
  hoverClass: string; 
  bankPendingClass: string;
  currEditFieldName: string;
  enableAutoFocus: boolean;
  accountIds: any;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const PayeeField: FC<PayeeFieldProps> = ({
  attributes,
  forceStatic,
  callbacks,
  editable,
  SHOW_ALL,
  txn,
  wrapClass, 
  editClass, 
  hoverClass, 
  bankPendingClass,
  currEditFieldName,
  enableAutoFocus,
  accountIds,
  focusField,
}) => {
  const { classes } = useStyles();
  const c2RTxnClass = isC2RTransaction(txn) ? classes.txnInC2RText : '';
  return (
    <RegListItem
      {...attributes}
      className={classNames(classes.regItem, 'flex2', wrapClass, editClass, hoverClass, bankPendingClass, c2RTxnClass)}
    >
      {SHOW_ALL &&
      <RegPayeeField
        editable={editable && currEditFieldName === 'payee'}
        txn={txn}
        autoFocus={enableAutoFocus}
        forceStatic={forceStatic}
        // @ts-expect-error: The expected type comes from property 'onChange' which is declared here on type 'IntrinsicAttributes & AmountFieldProps'
        onFocus={callbacks.handleFocus}
        // @ts-expect-error:  The expected type comes from property 'onChange' which is declared here on type 'IntrinsicAttributes & RegPayeeFieldProps'
        onChange={(e, fieldName, rawValue) => callbacks.handleChange(e, fieldName || 'payee', rawValue)}
        inputRef={(input) => { 
          focusField.current = input; // eslint-disable-line
        }}
        accountIds={accountIds}
      />}
    </RegListItem>
  );
};

export default PayeeField;
